const GENERIC_INSURANCE_LABELS = new Set([
  "accepting",
  "accepting insurance",
  "insurance accepted",
]);

function normalizeInsuranceCompany(value) {
  return String(value || "")
    .replace(/^accepts:\s*/i, "")
    .replace(/^insurance accepted:\s*/i, "")
    .trim();
}

export function parseInsurancePolicyText(value) {
  const raw = String(value || "").trim();
  if (!raw) {
    return { raw: "", companies: [], generic: false, hasActual: false };
  }

  const normalized = normalizeInsuranceCompany(raw);
  if (!normalized || /^not set$/i.test(normalized) || /^none$/i.test(normalized)) {
    return { raw, companies: [], generic: false, hasActual: false };
  }

  const lower = normalized.toLowerCase();
  if (GENERIC_INSURANCE_LABELS.has(lower)) {
    return { raw, companies: [], generic: true, hasActual: false };
  }

  const companies = Array.from(
    new Set(
      normalized
        .split(",")
        .map((item) => normalizeInsuranceCompany(item))
        .filter((item) => item && !GENERIC_INSURANCE_LABELS.has(item.toLowerCase()))
    )
  );

  return {
    raw,
    companies,
    generic: companies.length === 0 && /\baccept/i.test(normalized),
    hasActual: companies.length > 0,
  };
}

export function resolveInsuranceDisplay(...values) {
  let genericFallback = null;

  for (const value of values.flat()) {
    const parsed = parseInsurancePolicyText(value);
    if (parsed.hasActual) return parsed;
    if (parsed.generic && !genericFallback) genericFallback = parsed;
  }

  return genericFallback || { raw: "", companies: [], generic: false, hasActual: false };
}
